export enum AlignmentEnum {
    CENTER = 0,
    LEFT = 1,
    RIGHT = 2
}

export const AlignmentStyleMap: { [key in AlignmentEnum]: string } = {
    [AlignmentEnum.CENTER]: 'margin-left: auto; margin-right: auto;',
    [AlignmentEnum.LEFT]: 'margin-left: 0; margin-right: auto;',
    [AlignmentEnum.RIGHT]: 'margin-left: auto; margin-right: 0;'
};